exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2WiAco3-TX-UJMEWIn8_hr ::-webkit-input-placeholder {\n  font-style: italic;\n}\n._2WiAco3-TX-UJMEWIn8_hr :-moz-placeholder {\n  font-style: italic;\n}\n._2WiAco3-TX-UJMEWIn8_hr ::-moz-placeholder {\n  font-style: italic;\n}\n._2WiAco3-TX-UJMEWIn8_hr :-ms-input-placeholder {\n  font-style: italic;\n}\n", ""]);
// Exports
exports.locals = {
	"input-search": "_2WiAco3-TX-UJMEWIn8_hr"
};